const SIZE = {
  xs: { box: "h-7 w-7", text: "text-sm sm:text-base" },
  sm: { box: "h-9 w-9", text: "text-lg sm:text-xl" },
  md: { box: "h-11 w-11", text: "text-2xl" },
  lg: { box: "h-16 w-16", text: "text-4xl" },
  xl: { box: "h-24 w-24", text: "text-6xl sm:text-7xl" },
};

export default function BrandLogo({ size = "md", className = "", showWordmark = true }) {
  const s = SIZE[size] || SIZE.md;
  return (
    <div className={`flex items-center gap-2 select-none ${className}`}>
      <img
        src="/stakes-icon-192.png"
        alt="STAKES"
        className={`${s.box} object-contain neon-flicker`}
        draggable="false"
      />
      {showWordmark && (
        <span className={`brand-wordmark font-montserrat ${s.text}`}>STAKES</span>
      )}
    </div>
  );
}
